module.exports = __webpack_public_path__ + "img/password_icon.68b38d32.svg";